import { getShareActConfig } from '@tencent/wphk-components-help-friend';

type ShareCouponShowInfo = {
  isNeedInit: boolean;
  isNeedShow: boolean;
  spId?: string;
  shareSpId?: string;
};

export async function getShareCouponShowInfo(currSpId: string): Promise<ShareCouponShowInfo> {
  try {
    const shareCouponConf = await getShareActConfig();
    for (const config of shareCouponConf) {
      const adSpIdList = (config.adSpIdList || '').split('|').filter(ele => !!ele);
      if (adSpIdList.includes(currSpId)) {
        return {
          isNeedInit: true,
          isNeedShow: false,
          spId: config.spId,
          shareSpId: currSpId,
        };
      }
      if (config.spId === currSpId) {
        return {
          isNeedInit: true,
          isNeedShow: true,
          spId: config.spId,
          shareSpId: config.spId,
        };
      }
    }
    return {
      isNeedInit: false,
      isNeedShow: false,
    };
  } catch (error) {
    return {
      isNeedInit: false,
      isNeedShow: false,
    };
  }
}
